import { toast } from "react-toastify";
import { toastOptions } from "../../lib/toastOptions";

const handlefollowUser = async (senderId, receiverId) => {
  //  console.log('Sender of request', senderId);
  //  console.log('Receiver of request (user to follow)', receiverId);

  try {
    // Check if senderId and receiverId are the same
    if (senderId === receiverId) {
      console.log("Cannot follow yourself");
      return false;
    }
    toast.success("User followed successfully", toastOptions);

    const response = await fetch(
      process.env.REACT_APP_API + "/api/followUser",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ senderId, receiverId }),
      }
    );

    await response.json();
  } catch (error) {
    console.error("Error updating document: ", error);
  }

  return true;
};
export default handlefollowUser;
